module.exports = __webpack_public_path__ + "media/images/icons/kulturniMapa-e7866ec83d75a1db48614caea4730450.svg";